import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { Button } from "../components/ui/button";

export default function Maintenance() {
  const { general } = useSettings();
  return (
    <div className="app-shell min-h-screen bg-fx-base text-white flex items-center justify-center px-6" data-testid="maintenance-page">
      <div className="max-w-lg text-center">
        <img src={general.logo_url || "/logo.png"} alt={general.site_name} className="h-11 w-auto mx-auto mb-10" />
        <div className="h-16 w-16 rounded-2xl bg-brandblue/15 grid place-items-center text-brandblue mx-auto mb-6">
          <Wrench className="h-8 w-8" />
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">We'll be right back.</h1>
        <p className="text-lg text-fx-s3 mt-5 leading-relaxed">
          {general.site_name} is currently down for scheduled maintenance. We're making things better and will be back online shortly. Thank you for your patience.
        </p>
        <div className="mt-8">
          <Link to="/login">
            <Button variant="outline" data-testid="maintenance-login-btn" className="h-11 px-6 border-white/15 bg-white/5 hover:bg-white/10 text-white">Administrator sign in</Button>
          </Link>
        </div>
        {general.support_email && (
          <p className="text-sm text-fx-s3 mt-8">
            Need help? <a href={`mailto:${general.support_email}`} className="text-brandblue">{general.support_email}</a>
          </p>
        )}
      </div>
    </div>
  );
}
